import { render } from "./CreateKioskForm.vue?vue&type=template&id=d070c478"
import script from "./CreateKioskForm.vue?vue&type=script&lang=js"
export * from "./CreateKioskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__